import { Content } from './Content';
import { Drawer } from './Drawer';
import { Footer } from './Footer';
import { Header, HeaderAction, HeaderText } from './Header';

type ISidebar = typeof Drawer & {
  Content: typeof Content;
  Footer: typeof Footer;
  Header: typeof Header;
  HeaderAction: typeof HeaderAction;
  HeaderText: typeof HeaderText;
};

const DefaultSidebar = Drawer as ISidebar;

DefaultSidebar.Content = Content;
DefaultSidebar.Footer = Footer;
DefaultSidebar.Header = Header;
DefaultSidebar.HeaderText = HeaderText;
DefaultSidebar.HeaderAction = HeaderAction;

export { DefaultSidebar as Sidebar };
